export default __webpack_public_path__ + "static/media/BooksImage.06d85622.svg";